var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoInternet = function SvgNoInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 48,
    height: 48,
    rx: 24,
    fill: "none",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no-internet_svg__clip0_560_13537)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M35.86 29.2C36.1822 28.4393 36.3109 27.6106 36.2345 26.7881C36.1582 25.9655 35.8793 25.1746 35.4226 24.4862C34.966 23.7978 34.3459 23.2332 33.6177 22.843C32.8896 22.4527 32.0761 22.249 31.25 22.25H29.99C29.5818 20.6425 28.6841 19.2016 27.421 18.1267C26.158 17.0517 24.5921 16.3959 22.94 16.25M18.25 17.25C16.6881 18.1136 15.4598 19.4748 14.7606 21.1169C14.0614 22.759 13.9313 24.5878 14.3912 26.3123C14.8511 28.0369 15.8744 29.5581 17.2985 30.634C18.7225 31.7099 20.4654 32.2788 22.25 32.25H31.25C31.8298 32.2493 32.405 32.1478 32.95 31.95",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.25 13.25L36.25 35.25",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no-internet_svg__clip0_560_13537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13.25 12.25)"
  })))));
};
export default SvgNoInternet;